"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M12 6c-.03 0-.07 0-.1.01A5 5 0 002 7c0 .11.01.22.02.33A3.51 3.51 0 000 10.5C0 12.43 1.57 14 3.5 14H12c2.21 0 4-1.79 4-4s-1.79-4-4-4z"];
//# sourceMappingURL=cloud.js.map